import { ModuleWithProviders, NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { ProductLineComponent } from '../opc-app/productline/productline.component';
import { SupportComponent } from '../support/support.component';
import { ProductFamilyComponent } from '../opc-app/productfamily/productfamily.component';
import { PartGroupComponent } from '../opc-app/partgroup/partgroup.component';
import { PartCategoryComponent } from '../opc-app/partcategory/partcategory.component';
import { SearchResultComponent } from '../opc-app/searchresult/searchresult.component';
import { SearchResolver } from '../opc-app/searchresult/searchresolver';
import { PartDetailsComponent } from '../opc-app/part/partdetails/partdetails.component';
import { SigninComponent } from '../auth/signin/signin.component';
import { PartComponent } from '../opc-app/part/part.component';
import { AuthGuard } from '../auth/auth-guard-service';
import { ErrorComponent } from './error/error.component';
import { CallbacksComponent } from '../../app/callback/callbacks.component';
import { IdentityGuard } from '../auth/identity-service';
import { LogoutComponent } from '../logout/logout.component';

const appRoutes: Routes = [
  {
    path: '',
    component: CallbacksComponent,
  },
  {
    path: 'callback',
    component: CallbacksComponent,

  },
  {
    path: 'logOut',
    component: LogoutComponent,

  },
  {
    path: 'productfamily',
    component: ProductFamilyComponent,
    canActivate: [AuthGuard, IdentityGuard]
  },
  {
    path: 'productfamily/:pfid',
    component: ProductLineComponent,
    canActivate: [AuthGuard, IdentityGuard]
  },
  {
    path: 'productfamily/:pfid/productline/:plid',
    component: PartCategoryComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'productfamily/:pfid/productline/:plid/partcategory/:pcid',
    component: PartGroupComponent,
    canActivate: [AuthGuard, IdentityGuard]
  },
  {
    path: 'productfamily/:pfid/productline/:plid/partcategory/:pcid/partgroup/:pgid',
    component: PartComponent,
    canActivate: [AuthGuard, IdentityGuard]
  },
  {
    path: 'search/:text',
    component: SearchResultComponent,
    resolve:
    {
      search: SearchResolver
    },
    canActivate: [AuthGuard, IdentityGuard]
  },
  {
    path: 'search/:text/partgroup/:pgid',
    component: PartComponent,
    canActivate: [AuthGuard, IdentityGuard]
  },
  {
    path: 'support',
    component: SupportComponent,
    canActivate: [AuthGuard, IdentityGuard]
  },
  {
    path: 'error',
    component: ErrorComponent
  },
  {
    path: '**',
    redirectTo: 'productfamily'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes)
  ],
  exports: [RouterModule]
})

export class OPCRoutingModule {

}





// WEBPACK FOOTER //
// ./src/opc/opc-app/opc.module.routing.ts